import { render, staticRenderFns } from "./CreateSettlementNoKasbon.vue?vue&type=template&id=f0524210"
import script from "./CreateSettlementNoKasbon.vue?vue&type=script&lang=js"
export * from "./CreateSettlementNoKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports